import axios from "axios";
import cart from './shop-cart'; // Импортируем объект Cart

const DADATA_KEY = '83c7984234ed592b241cdc8b7723223f0c2ffb11';
const MOSCOW_CENTER = {lat: 55.7539, lon: 37.6208};
/* ===== helpers ===== */
const STORAGE_KEY = 'selectedCity';
const getCity = () => sessionStorage.getItem(STORAGE_KEY);
const setCity = c => {
    sessionStorage.setItem(STORAGE_KEY, c);
    const cityInput = document.getElementById('cart_city');
    if (cityInput) cityInput.textContent = c;
    const cityHeader = document.getElementById('cityName');
    if (cityHeader) cityHeader.textContent = c;
    window.dispatchEvent(new CustomEvent('city-changed', {detail: c}));
};

/* ===== debounce ===== */
const debounce = (fn, w) => {
    let t;
    return (...a) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...a), w);
    };
};

/* ===== поиск городов (универсальная функция) ===== */
async function searchCities(query, onSelect) {
    if (query.length < 2) return [];

    try {
        const {data} = await axios.post(
            'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
            {
                query: query,
                count: 10,
                from_bound: {value: 'city'},
                to_bound: {value: 'city'}
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: 'Token ' + DADATA_KEY
                }
            }
        );
        return data.suggestions;
    } catch (err) {
        console.error('DaData error:', err);
        return [];
    }
}

/* ===== авто-определение по IP ===== */
async function detectCityByIP() {
    if (getCity()) {
        setCity(getCity());
        return;
    }

    try {
        const {data} = await axios.get(
            'https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address',
            {
                // params: { ip: '' },
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Token ' + DADATA_KEY
                }
            }
        );
        const city = data.location?.data?.city || 'Москва';
        setCity(city);
    } catch {
        setCity('Москва');
    }
}

/* ===== модалка выбора города (главная страница) ===== */
function initCityModal() {
    const cityBtn = document.getElementById('cityBtn');
    const modal = document.getElementById('cityModal');
    const cityInput = document.getElementById('cityInput');
    const cityList = document.getElementById('cityList');
    const closeBtn = document.getElementById('closeModal');

    if (!cityBtn || !modal) return; // Элементов нет на странице

    const openModal = () => {
        modal.style.display = 'flex';
        cityInput?.focus();
    };

    const closeModal = () => {
        modal.style.display = 'none';
        if (cityInput) cityInput.value = '';
        if (cityList) cityList.innerHTML = '';
    };

    cityBtn.addEventListener('click', e => {
        e.preventDefault();
        openModal();
    });

    closeBtn?.addEventListener('click', closeModal);

    window.addEventListener('click', e => {
        if (e.target === modal) closeModal();
    });

    // Поиск в модалке
    cityInput?.addEventListener('input', debounce(async () => {
        const q = cityInput.value.trim();
        if (!cityList) return;

        if (q.length < 2) {
            cityList.innerHTML = '';
            return;
        }

        const suggestions = await searchCities(q);
        cityList.innerHTML = '';

        suggestions.forEach(item => {
            const li = document.createElement('li');
            li.textContent = item.data.city || item.value;
            li.addEventListener('click', () => {
                setCity(li.textContent);
                closeModal();
            });
            cityList.appendChild(li);
        });
    }, 300));
}

/* ===== подсказки для поля cart_city на странице /confirm ===== */
function initCartCityAutocomplete() {
    if (!window.location.pathname.includes('/confirm')) return;

    const cityInput = document.getElementById('cart_city');
    if (!cityInput) return;

    // Создаём контейнер для подсказок
    let suggestionsList = document.getElementById('cart-city-suggestions');
    if (!suggestionsList) {
        suggestionsList = document.createElement('ul');
        suggestionsList.id = 'cart-city-suggestions';
        suggestionsList.style.cssText = `
            position: absolute;
            background: white;
            list-style: none;
            margin: 0;
            padding: 0;
            max-height: 200px;
            overflow-y: auto;
            z-index: 1000;
            width: 100%;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        `;
        cityInput.parentNode.style.position = 'relative';
        cityInput.parentNode.appendChild(suggestionsList);
    }

    // Заполняем из sessionStorage
    const cityFromSession = sessionStorage.getItem('selectedCity');
    if (cityFromSession && !cityInput.value) {
        cityInput.value = cityFromSession;
    }

    // Обработчик ввода
    cityInput.addEventListener('input', debounce(async () => {
        const q = cityInput.value.trim();

        if (q.length < 2) {
            suggestionsList.innerHTML = '';
            suggestionsList.style.display = 'none';
            return;
        }

        const suggestions = await searchCities(q);
        suggestionsList.innerHTML = '';

        if (suggestions.length === 0) {
            suggestionsList.style.display = 'none';
            return;
        }

        suggestions.forEach(item => {
            const li = document.createElement('li');
            li.textContent = item.data.city_with_type + ", " + item.data.region_with_type || item.value;
            li.style.cssText = 'padding: 8px 12px; cursor: pointer;';
            li.addEventListener('mouseenter', () => li.style.background = '#f5f5f5');
            li.addEventListener('mouseleave', () => li.style.background = 'white');
            li.addEventListener('click', () => {
                cityInput.value = li.textContent;
                setCity(li.textContent);
                suggestionsList.innerHTML = '';
                suggestionsList.style.display = 'none';
            });
            suggestionsList.appendChild(li);
        });

        suggestionsList.style.display = 'block';
    }, 300));

    // Закрываем подсказки при клике вне
    document.addEventListener('click', (e) => {
        if (!cityInput.contains(e.target) && !suggestionsList.contains(e.target)) {
            suggestionsList.style.display = 'none';
        }
    });

    // Закрываем на Escape
    cityInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            suggestionsList.style.display = 'none';
        }
    });
}

/* ===== подсказки для улицы (опционально) ===== */
function initStreetAutocomplete() {
    if (!window.location.pathname.includes('/confirm')) return;

    const streetInput = document.getElementById('cart_street');
    const cityInput = document.getElementById('cart_city');
    if (!streetInput || !cityInput) return;

    let suggestionsList = document.getElementById('cart-street-suggestions');
    if (!suggestionsList) {
        suggestionsList = document.createElement('ul');
        suggestionsList.id = 'cart-street-suggestions';
        suggestionsList.style.cssText = `
            position: absolute;
            background: white;
            list-style: none;
            margin: 0;
            padding: 0;
            max-height: 200px;
            overflow-y: auto;
            z-index: 1000;
            width: 100%;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        `;
        streetInput.parentNode.style.position = 'relative';
        streetInput.parentNode.appendChild(suggestionsList);
    }

    streetInput.addEventListener('input', debounce(async () => {
        const q = streetInput.value.trim();
        const city = cityInput.value.trim();

        if (q.length < 3 || !city) {
            suggestionsList.innerHTML = '';
            suggestionsList.style.display = 'none';
            return;
        }

        try {
            const {data} = await axios.post(
                'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
                {
                    query: `${city} ${q}`,
                    count: 10,
                    from_bound: {value: 'street'},
                    to_bound: {value: 'street'}
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        Authorization: 'Token ' + DADATA_KEY
                    }
                }
            );

            suggestionsList.innerHTML = '';

            if (data.suggestions.length === 0) {
                suggestionsList.style.display = 'none';
                return;
            }

            data.suggestions.forEach(item => {
                const li = document.createElement('li');
                li.textContent = item.data.street || item.value;
                li.style.cssText = 'padding: 8px 12px; cursor: pointer; border-bottom: 1px solid #eee;';
                li.addEventListener('mouseenter', () => li.style.background = '#f5f5f5');
                li.addEventListener('mouseleave', () => li.style.background = 'white');
                li.addEventListener('click', () => {
                    streetInput.value = li.textContent;
                    suggestionsList.innerHTML = '';
                    suggestionsList.style.display = 'none';
                });
                suggestionsList.appendChild(li);
            });

            suggestionsList.style.display = 'block';
        } catch (err) {
            console.error('Street search error:', err);
        }
    }, 300));

    // Закрываем подсказки при клике вне
    document.addEventListener('click', (e) => {
        if (!streetInput.contains(e.target) && !suggestionsList.contains(e.target)) {
            suggestionsList.style.display = 'none';
        }
    });
}

/* ===== запуск ===== */
document.addEventListener('DOMContentLoaded', () => {
    detectCityByIP();
    initCityModal();
    initCartCityAutocomplete(); // Новая функция для /confirm
    initStreetAutocomplete();   // Опционально: подсказки улиц
});

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

async function getDistanceFromMoscow(cityName) {
    if (!cityName) return {error: 'Город не указан'};

    try {
        const response = await axios({
            method: 'get',
            url: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
            params: {
                query: cityName,
                count: 1,
                from_bound: JSON.stringify({value: 'city'}),
                to_bound: JSON.stringify({value: 'city'})
            },
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Token ' + DADATA_KEY
            }
        });

        const suggestion = response.data.suggestions?.[0];

        if (!suggestion) {
            return {error: `Город "${cityName}" не найден`};
        }

        const {geo_lat, geo_lon, city} = suggestion.data;

        if (!geo_lat || !geo_lon) {
            return {error: 'Координаты не найдены'};
        }

        const distance = getDistanceFromLatLonInKm(
            parseFloat(geo_lat),
            parseFloat(geo_lon),
            MOSCOW_CENTER.lat,
            MOSCOW_CENTER.lon
        );

        return {
            success: true,
            city: city,
            distance: Math.round(distance)
        };

    } catch (error) {
        return {
            success: false,
            error: error.response?.data?.message || error.message || 'Ошибка запроса'
        };
    }
}

document.addEventListener('DOMContentLoaded', function () {
        const cart_city = document.getElementById('cart_city');
        const radioInput3 = document.getElementById('cart_shippingMethod_3');

        const initialCity = cart_city?.value;
        toggleDeliveryByDistance(initialCity, 3, 80);
// Отслеживаем изменение (при потере фокуса)
        if (cart_city) {
            cart_city.addEventListener('change', async function () {
                    const cityName = this.value.trim();
                    cart.setPriceShipping(0, 0);
                // Сбросить все checked в группе доставки
                document.querySelectorAll('input[name="cart[shippingMethod]"]').forEach(radio => {
                    radio.checked = false;
                });
                    if (!cityName) return;
                toggleDeliveryByDistance(cityName, 3, 80);
                }
            );
        }
    }
);

function toggleDeliveryByDistance(cityName, methodId, maxDistance) {
    const radio = document.getElementById(`cart_shippingMethod_${methodId}`);
    if (!radio) return;

    const option = radio.closest('.delivery-option');

    if (!cityName) {
        option.style.display = 'none';
        return;
    }

    getDistanceFromMoscow(cityName).then(result => {
        if (result.success) {
            option.style.display = result.distance < maxDistance ? '' : 'none';
        } else {
            option.style.display = 'none';
            console.error(result.error);
        }
    });
}

